import React, { useState } from "react";
import * as styles from "./Hero.module.scss";
import { StaticImage } from "gatsby-plugin-image";
import useSearchQuery from "../../hooks/useSearchQuery";
import { Link } from "gatsby";

const HeroSection = ({ articles }) => {
  const [search, setSearch] = useState("");

  const searchResults = useSearchQuery({ search, data: articles });

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div className={styles.textWrapper}>
          <StaticImage
            src="../../assets/logo.png"
            alt="logo"
            placeholder="tracedSVG"
            imgStyle={{ objectFit: "contain" }}
            className={styles.logo}
          />
          <div className={styles.texts}>
            <h3>Overvejer du et holdingselskab eller har du allerede et?</h3>
            <p>Så er dette site til dig.</p>
          </div>
        </div>
        <div className={styles.searchWrapper}>
          <div className={styles.search}>
            <label>
              <input placeholder="Søg efter artikel" value={search} onChange={(e) => setSearch(e.target.value)} />
            </label>
            <button type="button">Søg</button>
            {!!searchResults.length && (
              <ul className={styles.searchResults}>
                {searchResults.map(({ uri, guideTitle }) => (
                  <li key={uri}>
                    <Link to={`/da/guide/${uri}`}>{guideTitle}</Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      <div className={styles.heroWrapper}>
        <StaticImage
          src="../../assets/hero.png"
          alt="hero"
          placeholder="tracedSVG"
          width={1170}
          quality={100}
          className={styles.hero}
          imgStyle={{ objectFit: "cover", objectPosition: "0 0" }}
        />
      </div>
    </div>
  );
};

export default HeroSection;
